import React from "react";
import { Alert, Box } from "@mui/material";
import HPDropdown from "@/components/common/Dropdown";
import type { ScorecardQuestionRow } from "@/models/Scorecard";

interface QuestionRowBaseExistingRowPickerProps {
  eligibleRows: ScorecardQuestionRow[];
  selectedRowId: string;
  onChange: (rowId: string) => void;
  isDisabled?: boolean;
}

/** Lists other eligible Percentage Question rows a row can use as its
 *  Scorecard Row Base — excludes Mean rows, itself, and any row that
 *  would form a cycle (already filtered into eligibleRows by the caller). */
const QuestionRowBaseExistingRowPicker: React.FC<QuestionRowBaseExistingRowPickerProps> = ({
  eligibleRows,
  selectedRowId,
  onChange,
  isDisabled,
}) => {
  if (eligibleRows.length === 0) {
    return (
      <Alert severity="info" sx={{ py: 0.5 }}>
        No other eligible Percentage Question rows yet — add one first, or use a New
        Question Base instead.
      </Alert>
    );
  }

  const options = eligibleRows.map((row) => ({
    value: row.id,
    label: `${row.label} (${row.sourceQuestionLabel})`,
  }));

  return (
    <Box sx={{ mt: 1 }}>
      <HPDropdown
        label="Existing Question Row*"
        value={selectedRowId}
        onChange={onChange}
        placeholder="Choose a Question row"
        options={options}
        disabled={isDisabled}
      />
    </Box>
  );
};

export default QuestionRowBaseExistingRowPicker;
